import * as yup from "yup";
import {
  stringNullable,
  stringNullableRequired,
  stringRequired,
  numberNatural,
} from "yup/defaultValudations";

export const schema = yup.object().shape({
  organizationName: stringRequired(),
  price: numberNatural(),
  validUntil: stringNullableRequired(),
  companyNumber: stringNullable(),
});
